import { formatISO } from 'date-fns';

import { withHeaders } from './with-headers';

const USER_DATETIME_HEADER = 'x-user-datetime';

export const withDateTimeHeaders = withHeaders(() => ({
  [USER_DATETIME_HEADER]: formatISO(new Date())
}));
